// Event lifecycle helpers — single source of truth for "what's editable
// when?" decisions across the GM surfaces.

// Pre-live: content (bounties, FRAGOs, equipment, checkpoints) can still
// be tweaked. The GM is either still building, or running registration,
// or in the prep stretch right before kickoff. Once the event flips to
// 'live' / 'active' / 'endex' / 'closed' / 'cancelled', the field is in
// motion and content edits would be confusing.
const CONTENT_EDITABLE_STATUSES = new Set([
  'draft',
  'prep',
  'registration',
  'pending',
  'scheduled',
])

// Settings-editable: tighter. Once registration opens, players have
// signed up under one set of rules — changing them silently after the
// fact would surprise people. UX-4 from the morning brief.
const SETTINGS_EDITABLE_STATUSES = new Set([
  'draft',
  'prep',
  'pending',
])

export function isContentEditable(eventOrStatus) {
  const status = typeof eventOrStatus === 'string' ? eventOrStatus : eventOrStatus?.status
  return CONTENT_EDITABLE_STATUSES.has(status)
}

export function isSettingsEditable(eventOrStatus) {
  const status = typeof eventOrStatus === 'string' ? eventOrStatus : eventOrStatus?.status
  return SETTINGS_EDITABLE_STATUSES.has(status)
}

// Convenience inverse for guard expressions that read better as "locked".
export function isSettingsLocked(eventOrStatus) {
  return !isSettingsEditable(eventOrStatus)
}
